import { useEffect } from "react";
import { Nav, Footer } from "../components/Nav";

import cover from "../images/TaskBuddy/Taskbuddy Video.gif";
import loginImg from "../images/TaskBuddy/Login Page.jpg";
import todoImg from "../images/TaskBuddy/Task Page.jpg";
import addImg from "../images/TaskBuddy/Task Page-1.jpg";
import startImg from "../images/TaskBuddy/Taskbuddy Greeting.png";
import {
  ProjectInfo,
  TextSection,
  MoreSection,
} from "../components/ProjectDetails";

export default function TaskBuddy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <header id="project-cover">
        <Nav color="white" />

        <h1>Task Buddy</h1>
        <p>Web-based Kanban Task Management App</p>
        <img id="cover" src={cover} alt="TaskBuddy Cover" />
      </header>

      <main id="project-detail-main">
        <ProjectInfo
          role={["Full Stack Developer"]}
          team={["3 Members", "Siddhi Kabadi", "Shreya Pothineni"]}
          toolkit={["HTML/CSS", "PHP", "SQLite"]}
          duration="1 Month (2024)"
        />

        <TextSection type="callout" header="project overview" title="The Goal">
          <p>
            The goal was to develop a user-friendly web application inspired by
            Kanban task management, enabling users to efficiently track their
            to-do lists. The application allows users to create personal
            accounts and securely access their saved tasks within the database.
          </p>
          <a
            href="https://github.com/tsaichenlin/taskbuddy"
            className="primary-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Code on Github
          </a>
        </TextSection>

        <TextSection
          type="normal-text"
          header="My role"
          title="Key Contributions"
        >
          <p>
            I took a lead role in the project, overseeing the entire
            process—from brainstorming ideas and delegating tasks to delivering
            the final product. I was responsible for designing and developing an
            intuitive user interface, building the backend database, and
            integrating the front and back end.
          </p>
          <ul>
            <li>
              Designed the user interface and created a medium-fidelity
              prototype.
            </li>
            <li>
              Converted the design into a fully functional web application.
            </li>
            <li>Developed the database using SQLite and PHP.</li>
            <li>
              Implemented dynamic functionalities, such as adding and updating
              to-dos.
            </li>
            <li>
              Fetched and displayed data from the database for seamless
              interaction.
            </li>
          </ul>
        </TextSection>

        <TextSection
          type="callout"
          header="Feature Walkthrough"
          title="Login and Sign Up"
        >
          <p>
            Users can create an account or log in to save, update, and manage
            their to-do lists.
          </p>
          <img src={loginImg} alt="Task Buddy Login Page" />
        </TextSection>

        <TextSection
          type="callout"
          header="Feature Walkthrough"
          title="Start Page with Greetings and Mood Tracking"
        >
          <p>
            The Start Page welcomes users with a personalized message based on
            the time of day and features a mood tracking tool that sets their
            profile photo for the day.
          </p>
          <img src={startImg} alt="Task Buddy Start Page" />
        </TextSection>

        <TextSection
          type="callout"
          header="Feature Walkthrough"
          title="Adding To-Dos"
        >
          <p>
            Users can quickly add and organize tasks through an intuitive
            interface.
          </p>
          <img src={addImg} alt="Task Buddy Add To-do Page" />
        </TextSection>

        <TextSection
          type="callout"
          header="Feature Walkthrough"
          title="Kanban Board Style To-Do List"
        >
          <p>
            Organize tasks with a Kanban board view, allowing users to manage
            and visualize their to-do lists. Easily move tasks between different
            statuses to track progress and prioritize efficiently.
          </p>
          <img src={todoImg} alt="Task Buddy Task Page" />
        </TextSection>
      </main>
      <MoreSection exclude={["taskbuddy"]} />
      <Footer />
    </>
  );
}
